import React, { useState, useEffect } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Navbars';
import Footer from '../Footer';

function SignUp() {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        let timer;
        if (error) {
            timer = setTimeout(() => {
                setError('');
            }, 15000);
        }
        return () => clearTimeout(timer);
    }, [error]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');
        try {
            const response = await fetch('https://api.mariabird.net/SWS/register', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ name, email, password }),
            });
            if (response.ok) {
                console.log('Inscription réussie');
                navigate('/login');
            } else {
                console.log('Échec de la connexion');
                setError('Un utilisateur avec cet email existe déjà.');
            }
        } catch (error) {
            console.error('Erreur de connexion', error);
            setError('Une erreur s’est produite. Veuillez réessayer.');
        }
    };

    return (
        <>
            <Navbar />
            <br />
      <Typography variant="h3" align="center" style={{ marginBottom: '20px', color: 'white'  }}>
        Register
      </Typography>
      <br />
            <Box component="form" role="form" onSubmit={handleSubmit} maxWidth="400px" mx="auto" mt={4} p={2}>
                {error && (
                    <Box mb={2} bgcolor="error.main" color="error.contrastText" p={1} borderRadius={4}>
                        <Typography variant="body2">{error}</Typography>
                    </Box>
                )}
                <Box mb={2}>
                    <TextField
                        type="text"
                        label="Username"
                        fullWidth
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Username"
                    />
                </Box>
                <Box mb={2}>
                    <TextField
                        type="email"
                        label="Email"
                        fullWidth
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Votre email..."
                    />
                </Box>
                <Box mb={2}>
                    <TextField
                        type="password"
                        label="Password"
                        fullWidth
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Votre mot de passe..."
                    />
                </Box>
                <Box mt={4} mb={1}>
                    <Button type="submit" variant="contained" color="primary" fullWidth>
                        S'INSCRIRE
                    </Button>
                </Box>
                <Box mt={3} textAlign="center">
                    <Typography variant="body2" color="text.primary">
                        Vous avez déjà un compte?{' '}
                        <Typography
                            component="a"
                            href="/login"
                            variant="body2"
                            color="primary"
                            fontWeight="bold"
                        >
                            Se connecter
                        </Typography>
                    </Typography>
                </Box>
            </Box>
            <Footer />
        </>
    );
}

export default SignUp;
